/* eslint-disable */
// src/services/pushTokenService.js
// ✅ members 컬렉션 기반 FCM 토큰 저장 (phoneE164로 member 찾고 문서에 merge)

import { db } from "./firebase";
import {
    collection,
    query,
    where,
    getDocs,
    doc,
    setDoc,
    serverTimestamp,
} from "firebase/firestore";

export async function saveFcmTokenForMember({ phoneE164, token, platform }) {
    if (!phoneE164) throw new Error("saveFcmTokenForMember: phoneE164 is required");
    if (!token) throw new Error("saveFcmTokenForMember: token is required");

    const q = query(collection(db, "members"), where("phoneE164", "==", phoneE164));
    const snap = await getDocs(q);

    if (snap.empty) {
        throw new Error(`saveFcmTokenForMember: member not found for ${phoneE164}`);
    }

    const memberDoc = snap.docs[0];
    const memberRef = doc(db, "members", memberDoc.id);

    const patch = {
        fcmTokens: {
            [token]: {
                platform: platform || "unknown",
                updatedAt: serverTimestamp(),
            },
        },
        fcmTokensUpdatedAt: serverTimestamp(),
    };

    await setDoc(memberRef, patch, { merge: true });

    return memberDoc.id;
}

export async function flushPendingFcmTokenIfAny({ phoneE164 }) {
    console.log("[FCM][FLUSH] start phoneE164 =", phoneE164);

    if (!phoneE164) {
        console.log("[FCM][FLUSH] no phoneE164 -> skip");
        return false;
    }

    let pending = null;
    try {
        const raw = localStorage.getItem("PENDING_FCM_TOKEN");
        pending = raw ? JSON.parse(raw) : null;
    } catch (e) {
        console.log("[FCM][FLUSH] localStorage parse error =", String(e?.message || e));
    }

    console.log("[FCM][FLUSH] pending =", pending);

    if (!pending?.token) {
        console.log("[FCM][FLUSH] no pending token -> skip");
        return false;
    }

    await saveFcmTokenForMember({
        phoneE164,
        token: pending.token,
        platform: pending.platform,
    });

    try {
        localStorage.removeItem("PENDING_FCM_TOKEN");
    } catch { }

    if (window.__PENDING_FCM_TOKEN__?.token === pending.token) {
        window.__PENDING_FCM_TOKEN__ = null;
    }

    console.log("[FCM][FLUSH] done");
    return true;
}

